@import '../../global/styles/inputs/input-field';
@import '../../global/styles/inputs/input-label';
@import '../../global/styles/inputs/input-helper-text';

:host {
  display: block;
  position: relative;
  font-family: var(--lgr-font-family-regular);
  font-size: var(--lgr-font-size-md);

  .lgr-select-expand-icon {
    margin-left: auto;
    pointer-events: none;
    transition: all 250ms;
    font-size: var(--lgr-font-size-xl);

    &.lgr-open-list {
      transform: rotate(180deg);
    }

    &.lgr-closed-list {
      transform: rotate(0deg);
    }
  }

  .custom-select {
    display: flex;
    position: relative;
    align-items: center;
    color: var(--lgr-color-neutral-low-pure);
    appearance: none;
    overflow: hidden;

    p {
      margin: 0;
      padding-right: var(--lgr-spacing-xxxs);
      text-overflow: ellipsis;
      overflow: hidden;

      &.placeholder {
        -webkit-user-select: none; /* stylelint-disable-line */
        user-select: none;
      }
    }

    &.none {
      height: 0;
      border: unset;
    }
  }

  .custom-select,
  .lgr-select-expand-icon {
    &.dark {
      color: var(--lgr-color-neutral-low-dark);
      border-color: var(--lgr-color-neutral-low-dark);
    }

    &.success {
      color: var(--lgr-color-success);
    }

    &.error {
      color: var(--lgr-color-error);
    }

    &.disabled {
      color: var(--lgr-color-neutral-low-light);
      border-color: var(--lgr-color-neutral-low-light);
    }

    &.inverse {
      color: var(--lgr-color-neutral-high-pure);
    }
  }

  .options-list {
    position: absolute;
    width: 100%;
    max-height: var(--lgr-spacing-huge);
    margin: var(--lgr-spacing-quarck) 0 0;
    padding: 0;
    border-radius: var(--lgr-border-radius-sm);
    background-color: var(--lgr-color-neutral-high-pure);
    line-height: var(--lgr-spacing-sm);
    list-style: none;
    box-shadow: var(--lgr-shadow-down-lg);
    z-index: 1;
    overflow-y: auto;
  }
}
